/* Lumia — pages.js: article share row (copy link, native share) + password page helpers.
   Vanilla ES2019, no dependencies. Works without window.Lumia; uses Lumia.toast / Lumia.drawer
   only when they exist (global.js is deferred before this file, so they are ready on DOMContentLoaded). */
(function () {
  'use strict';

  var doc = document;

  function ready(fn) {
    if (doc.readyState !== 'loading') fn();
    else doc.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------------------------------------------------------------- */
  /* Clipboard                                                         */
  /* ---------------------------------------------------------------- */
  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      try {
        var ta = doc.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.setAttribute('aria-hidden', 'true');
        ta.style.position = 'fixed';
        ta.style.top = '0';
        ta.style.left = '0';
        ta.style.opacity = '0';
        doc.body.appendChild(ta);
        ta.select();
        ta.setSelectionRange(0, ta.value.length);
        var ok = doc.execCommand('copy');
        doc.body.removeChild(ta);
        if (ok) resolve();
        else reject(new Error('copy failed'));
      } catch (err) {
        reject(err);
      }
    });
  }

  function announce(btn, message, ok) {
    var live = doc.querySelector('[data-copy-status]');
    if (live) {
      live.textContent = '';
      // force re-announce of identical text
      window.setTimeout(function () { live.textContent = message; }, 20);
    }
    if (window.Lumia && typeof window.Lumia.toast === 'function' && message) {
      window.Lumia.toast(message, { type: ok ? 'success' : 'error' });
    }
    var label = btn.querySelector('[data-copy-label]');
    if (label) {
      if (!btn.hasAttribute('data-copy-original')) {
        btn.setAttribute('data-copy-original', label.textContent);
      }
      var original = btn.getAttribute('data-copy-original');
      label.textContent = message || original;
      btn.classList.toggle('is-copied', !!ok);
      window.clearTimeout(btn._lhCopyTimer);
      btn._lhCopyTimer = window.setTimeout(function () {
        label.textContent = original;
        btn.classList.remove('is-copied');
      }, 2200);
    }
  }

  function onCopyClick(event) {
    var btn = event.target.closest('[data-copy-link]');
    if (!btn) return;
    event.preventDefault();
    var url = btn.getAttribute('data-copy-link') || window.location.href;
    var okText = btn.getAttribute('data-copied-text') || '';
    var errText = btn.getAttribute('data-copy-error') || '';
    copyText(url).then(
      function () { announce(btn, okText, true); },
      function () { announce(btn, errText, false); }
    );
  }

  /* ---------------------------------------------------------------- */
  /* Native share (Web Share API) — buttons stay hidden when unsupported */
  /* ---------------------------------------------------------------- */
  function revealNativeShare() {
    if (!navigator.share) return;
    var buttons = doc.querySelectorAll('[data-share-native][hidden]');
    for (var i = 0; i < buttons.length; i++) buttons[i].hidden = false;
  }

  function onShareClick(event) {
    var btn = event.target.closest('[data-share-native]');
    if (!btn || !navigator.share) return;
    event.preventDefault();
    var data = {
      title: btn.getAttribute('data-share-title') || doc.title,
      text: btn.getAttribute('data-share-text') || '',
      url: btn.getAttribute('data-share-url') || window.location.href
    };
    try {
      navigator.share(data).catch(function () { /* user cancelled */ });
    } catch (err) { /* ignore */ }
  }

  /* ---------------------------------------------------------------- */
  /* Comments: bring the posted/errored form message into view         */
  /* ---------------------------------------------------------------- */
  function focusFormMessage() {
    var target = doc.querySelector('[data-scroll-into-view]');
    if (!target) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (typeof target.scrollIntoView === 'function') {
      target.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
    }
    if (target.hasAttribute('tabindex')) {
      try { target.focus({ preventScroll: true }); } catch (err) { target.focus(); }
    }
  }

  /* ---------------------------------------------------------------- */
  /* Password page: reopen the login drawer after a failed attempt     */
  /* ---------------------------------------------------------------- */
  function reopenPasswordDrawer() {
    var marker = doc.querySelector('[data-password-error]');
    if (!marker) return;
    var drawer = marker.closest('lh-drawer');
    if (!drawer) return;
    var open = function () {
      if (window.Lumia && window.Lumia.drawer && typeof window.Lumia.drawer.open === 'function') {
        window.Lumia.drawer.open(drawer.id, null, { instant: true });
      } else if (typeof drawer.open === 'function') {
        drawer.open(null, { instant: true });
      }
    };
    if (window.customElements && typeof customElements.whenDefined === 'function') {
      customElements.whenDefined('lh-drawer').then(open, open);
    } else {
      open();
    }
  }

  ready(function () {
    doc.addEventListener('click', onCopyClick);
    doc.addEventListener('click', onShareClick);
    revealNativeShare();
    focusFormMessage();
    reopenPasswordDrawer();
  });
})();
